import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";

const ACTION_PREFIX = "[Loading]";
export const LOADING_ACTION_TYPE = {
	open: `${ACTION_PREFIX} Open ${SYNC_SUFFIX}`,
	close: `${ACTION_PREFIX} Close ${SYNC_SUFFIX}`,
	clear: `${ACTION_PREFIX} Close ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class LoadingAction {
	open(): Action {
		return {
			type: LOADING_ACTION_TYPE.open,
		};
	}

	close(): Action {
		return {
			type: LOADING_ACTION_TYPE.close,
		};
	}

	clear(): Action {
		return {
			type: LOADING_ACTION_TYPE.clear,
		};
	}
}
